<script setup>
import { computed } from 'vue'
import { RouterView } from 'vue-router'
import ClientSplitLayout from './ClientSplitLayout.vue'
import ClientDashboardLayout from './ClientDashboardLayout.vue'
import ClientDataLayout from './ClientDataLayout.vue'
import ClientSystemLayout from './ClientSystemLayout.vue'

const layoutMap = {
  split: ClientSplitLayout,
  dashboard: ClientDashboardLayout,
  data: ClientDataLayout,
  system: ClientSystemLayout,
}

const fallbackLayout = ClientDataLayout

const resolveLayout = (routeMeta) => {
  // Централизованно определяем layout по meta.layout, чтобы страницы не дублировали shell-логику.
  const layoutName = routeMeta?.layout || 'data'
  return layoutMap[layoutName] || fallbackLayout
}

const getLayoutProps = (routeMeta) => {
  const layoutName = routeMeta?.layout || 'data'
  return {
    layoutName,
  }
}
</script>

<template>
  <RouterView v-slot="{ Component, route: currentRoute }">
    <component
      :is="resolveLayout(currentRoute.meta)"
      v-bind="getLayoutProps(currentRoute.meta)"
    >
      <component :is="Component" />
    </component>
  </RouterView>
</template>
